import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectSelectedChannel } from '../../../../store/app.selectors';
import { BaseComponent } from '../../../shared/components/base/base.component';
import { setSmartReplieSelected } from '../../store/chat.actions';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-standard-responses',
  templateUrl: './standard-responses.component.html',
  styleUrls: ['./standard-responses.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StandardResponsesComponent extends BaseComponent {
  private store = inject(Store<AppStateWithChat>);

  selectedChannel = toSignal(this.store.select(selectSelectedChannel), { initialValue: null });

  selectAutoResponse(response: string): void {
    this.store.dispatch(setSmartReplieSelected({ messages: response }));
    setTimeout(() => {
      this.store.dispatch(setSmartReplieSelected({ messages: null }));
    });
  }
}
